import { render, staticRenderFns } from "./standalone.vue?vue&type=template&id=2241c1f4&scoped=true&"
import script from "./standalone.vue?vue&type=script&lang=js&"
export * from "./standalone.vue?vue&type=script&lang=js&"
import style0 from "./standalone.vue?vue&type=style&index=0&id=2241c1f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241c1f4",
  null
  
)

export default component.exports